module.exports = __webpack_public_path__ + "img/antes_despues_101.61bcc836.png";